<template>
    <div ref="trackview" class="track-library overflow-y-auto h-screen-header">
        <section class="track-hero">
            <div class="track-hero__copy">
                <div class="track-hero__label">{{ $tt('歌曲收藏') }}</div>
                <h1>{{ $tt('用工作台方式整理每一首歌') }}</h1>
                <p>{{ $tt('快速切换排序和视图，直接播放全部或随机试听，列表里继续完成批量选择和元数据编辑。') }}</p>
                <div class="track-hero__actions">
                    <button type="button" class="btn btn-primary btn-sm" :disabled="!albums.length" @click="playAll">
                        {{ $tt('播放全部') }}
                    </button>
                    <button type="button" class="btn btn-outline btn-sm" :disabled="!albums.length" @click="playRandom">
                        {{ $tt('随机播放') }}
                    </button>
                    <button type="button" class="btn btn-ghost btn-sm" :disabled="loading" @click="refreshCurrentPage">
                        {{ $tt('刷新') }}
                    </button>
                </div>
            </div>
            <div class="track-hero__deck" aria-hidden="true">
                <div
                    v-for="(track, index) in heroTracks"
                    :key="`${track.id || index}_${index}`"
                    class="track-strip"
                    :style="{ '--track-index': index }"
                >
                    <img :src="track.image || '/static/dist/img/album_null.jpg'" alt="">
                    <div>
                        <strong>{{ track.title || $tt('未命名歌曲') }}</strong>
                        <span>{{ track.artist || '-' }}</span>
                    </div>
                </div>
            </div>
        </section>

        <section class="track-toolbar">
            <div class="track-toolbar__tabs scrollbar-hide">
                <button
                    v-for="{ value, text } in options"
                    :key="value"
                    type="button"
                    :class="['track-tab', sortValue === value ? 'is-active' : '']"
                    @click="switchSort(value)"
                >
                    {{ $tt(text) }}
                </button>
            </div>
            <div class="track-toolbar__actions">
                <button
                    type="button"
                    :class="['track-icon-button', showMode === 'card' ? 'is-active' : '']"
                    :title="$tt('卡片视图')"
                    @click="showMode = 'card'"
                >
                    <svg class="icon w-5 h-5 fill-current" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                        <path d="M170.666667 85.333333a85.333333 85.333333 0 0 0-85.333334 85.333334v213.333333a85.333333 85.333333 0 0 0 85.333334 85.333333h213.333333a85.333333 85.333333 0 0 0 85.333333-85.333333V170.666667a85.333333 85.333333 0 0 0-85.333333-85.333334H170.666667zM170.666667 554.666667a85.333333 85.333333 0 0 0-85.333334 85.333333v213.333333a85.333333 85.333333 0 0 0 85.333334 85.333334h213.333333a85.333333 85.333333 0 0 0 85.333333-85.333334v-213.333333a85.333333 85.333333 0 0 0-85.333333-85.333333H170.666667zM640 85.333333a85.333333 85.333333 0 0 0-85.333333 85.333334v213.333333a85.333333 85.333333 0 0 0 85.333333 85.333333h213.333333a85.333333 85.333333 0 0 0 85.333334-85.333333V170.666667a85.333333 85.333333 0 0 0-85.333334-85.333334h-213.333333zM640 554.666667a85.333333 85.333333 0 0 0-85.333333 85.333333v213.333333a85.333333 85.333333 0 0 0 85.333333 85.333334h213.333333a85.333333 85.333333 0 0 0 85.333334-85.333334v-213.333333a85.333333 85.333333 0 0 0-85.333334-85.333333h-213.333333z"></path>
                    </svg>
                </button>
                <button
                    type="button"
                    :class="['track-icon-button', showMode === 'list' ? 'is-active' : '']"
                    :title="$tt('列表视图')"
                    @click="showMode = 'list'"
                >
                    <svg class="icon w-5 h-5 fill-current" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                        <path d="M134.976 853.312H89.6c-26.56 0-46.912-20.928-46.912-48.256 0-27.392 20.352-48.32 46.912-48.32h45.376c26.624 0 46.912 20.928 46.912 48.32 0 27.328-20.288 48.256-46.912 48.256zM134.976 560.32H89.6C63.04 560.32 42.688 539.392 42.688 512s20.352-48.32 46.912-48.32h45.376c26.624 0 46.912 20.928 46.912 48.32s-20.288 48.32-46.912 48.32zM134.976 267.264H89.6c-26.56 0-46.912-20.928-46.912-48.32 0-27.328 20.352-48.256 46.912-48.256h45.376c26.624 0 46.912 20.928 46.912 48.256 0 27.392-20.288 48.32-46.912 48.32zM311.744 853.312c-26.56 0-46.912-20.928-46.912-48.256 0-27.392 20.352-48.32 46.912-48.32h622.72c26.56 0 46.848 20.928 46.848 48.32 0 27.328-20.288 48.256-46.912 48.256H311.744c1.6 0 1.6 0 0 0zM311.744 560.32c-26.56 0-46.912-20.928-46.912-48.32s20.352-48.32 46.912-48.32h622.72c26.56 0 46.848 20.928 46.848 48.32s-20.288 48.32-46.912 48.32H311.744c1.6 0 1.6 0 0 0zM311.744 267.264c-26.56 0-46.912-20.928-46.912-48.32 0-27.328 20.352-48.256 46.912-48.256h622.72c26.56 0 46.848 20.928 46.848 48.256 0 27.392-20.288 48.32-46.912 48.32H311.744c1.6 0 1.6 0 0 0z"></path>
                    </svg>
                </button>
            </div>
        </section>

        <section class="track-status-strip">
            <div>
                <span class="track-status-strip__label">{{ $tt('当前规则') }}</span>
                <strong>{{ currentSortLabel }}</strong>
            </div>
            <div>
                <span class="track-status-strip__label">{{ $tt('已载入') }}</span>
                <strong>{{ albums.length }}</strong>
            </div>
            <div>
                <span class="track-status-strip__label">{{ $tt('总时长') }}</span>
                <strong>{{ loadedDurationLabel }}</strong>
            </div>
            <div>
                <span class="track-status-strip__label">{{ $tt('艺术家') }}</span>
                <strong>{{ artistCount }}</strong>
            </div>
        </section>

        <section class="track-content">
            <TrackList
                v-if="albums.length"
                :tracks="albums"
                :index-field="'index'"
                :view-mode="showMode === 'card' ? 'card' : 'list'"
            />

            <div v-if="loading" class="track-loading">
                <div class="track-loading__rows">
                    <span v-for="index in 6" :key="index"></span>
                </div>
                <p>{{ $tt('正在载入歌曲') }}</p>
            </div>

            <div v-if="!loading && albums.length === 0" class="track-empty">
                <div class="track-empty__art">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <h3>{{ $tt('暂无音乐') }}</h3>
                <p>{{ $tt('还没有找到任何音乐，可以切换排序或调整搜索关键词。') }}</p>
            </div>
        </section>

        <button v-if="curScrollTop > 700" @click="scrollToTop" class="track-scroll-top" :title="$tt('返回顶部')">
            <svg class="icon h-5 w-5 fill-current" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                <path d="M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3c-3.8 5.3-0.1 12.7 6.5 12.7h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z"></path>
            </svg>
        </button>
    </div>
</template>

<script>
import TrackList from './TrackList'
import { mapGetters } from 'vuex'

export default {
    name: 'tracks',
    components: {
        TrackList
    },
    data() {
        return {
            albums: [],
            loading: false,
            offset: 0,
            hasMore: true,
            showMode: 'card',
            curScrollTop: 0,
            watchSearchTerm: null,
            searchTimeout: null
        }
    },
    computed: {
        ...mapGetters(['getSearchTerm', 'trackId']),
        options() {
            return [
                { text: '最近添加', value: 'recently-added' },
                { text: '最近播放', value: 'recently-played' },
                { text: '最多播放', value: 'most-played' },
                { text: 'A-Z排序', value: 'a-z' }
            ]
        },
        sortValue() {
            return this.$route.params.sort
        },
        currentSortLabel() {
            const option = this.options.find(item => item.value === this.sortValue)
            return option ? this.$tt(option.text) : this.$tt('最近添加')
        },
        heroTracks() {
            const tracks = this.albums.slice(0, 4)
            while (tracks.length < 4) {
                tracks.push({})
            }
            return tracks
        },
        loadedDurationLabel() {
            const totalSeconds = this.albums.reduce((sum, track) => sum + Number(track.duration || 0), 0)
            return this.formatDurationLong(totalSeconds)
        },
        artistCount() {
            return new Set(this.albums.map(track => track.artist).filter(Boolean)).size
        }
    },
    created() {
        this.resetAndLoad()
        this.startWatching()
    },
    activated() {
        this.bindScrollListener()
        this.restoreScroll()
        this.startWatching()
    },
    deactivated() {
        this.unbindScrollListener()
        this.stopWatching()
    },
    beforeDestroy() {
        this.unbindScrollListener()
        this.stopWatching()
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout)
            this.searchTimeout = null
        }
    },
    mounted() {
        this.bindScrollListener()
        this.restoreScroll()
    },
    methods: {
        bindScrollListener() {
            if (this.$refs.trackview) {
                this.$refs.trackview.addEventListener('scroll', this.listenBottomOut)
                window.trackview = this.$refs.trackview
            }
        },
        unbindScrollListener() {
            if (this.$refs.trackview) {
                this.$refs.trackview.removeEventListener('scroll', this.listenBottomOut, false)
            }
        },
        restoreScroll() {
            if (this.$refs.trackview) {
                this.$refs.trackview.scrollTop = this.curScrollTop || 0
            }
        },
        startWatching() {
            if (!this.watchSearchTerm) {
                this.watchSearchTerm = this.$watch('getSearchTerm', this.loadSearchTimeout)
            }
        },
        stopWatching() {
            if (this.watchSearchTerm) {
                this.watchSearchTerm()
                this.watchSearchTerm = null
            }
        },
        resetState() {
            this.offset = 0
            this.albums = []
            this.hasMore = true
            this.curScrollTop = 0
        },
        resetAndLoad() {
            this.resetState()
            if (this.getSearchTerm) {
                return this.loadSearch()
            }
            return this.loadMore()
        },
        refreshCurrentPage() {
            if (this.loading) {
                return
            }
            return this.resetAndLoad()
        },
        loadMore() {
            if (this.loading || !this.hasMore || this.getSearchTerm) {
                return
            }
            this.loading = true
            return this.$api.subsonic.getTracksByGenre(this.sortValue, 50, this.offset).then(albums => {
                this.albums.push(...albums)
                this.offset += albums.length
                this.hasMore = albums.length > 0
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        loadSearch() {
            if (this.getSearchTerm === '') {
                this.resetState()
                return this.loadMore()
            }
            this.loading = true
            this.offset = 0
            this.hasMore = true
            return this.$api.subsonic.searchTracksByGenre('search', this.getSearchTerm, 30, this.offset).then(albums => {
                this.albums = albums
                this.offset += albums.length
                this.hasMore = albums.length > 0
                this.loading = false
            }).catch((err) => {
                this.loading = false
                if (err.message === 'Wrong username or password.') {
                    this.$myMsg.notify({
                        title: this.$tt('查询失败！'),
                        content: this.$tt('请在后台管理创建一个subsonic密码，刷新页面试试吧'),
                        type: 'error',
                        time: 5000,
                        url: '/admin/user/userprofile/'
                    })
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('查询失败！'),
                        content: err.messagee ? err.message : this.$tt('创建失败'),
                        type: 'error',
                        time: 5000
                    })
                }
            })
        },
        loadSearchTimeout() {
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout)
            }
            this.searchTimeout = setTimeout(() => {
                this.searchTimeout = null
                this.resetAndLoad()
            }, 500)
        },
        listenBottomOut() {
            if (!this.hasMore || this.loading || this.getSearchTerm || !this.$refs.trackview) {
                return
            }
            const scroller = this.$refs.trackview
            const scrollTop = scroller.scrollTop
            const scrollHeight = scroller.scrollHeight
            const clientHeight = scroller.clientHeight
            this.curScrollTop = scrollTop
            if (scrollTop + clientHeight >= scrollHeight - 120) {
                this.loadMore()
            }
        },
        scrollToTop() {
            if (this.$refs.trackview) {
                this.$refs.trackview.scrollTo({ top: 0, behavior: 'smooth' })
            }
        },
        switchSort(value) {
            if (value === this.sortValue) {
                this.refreshCurrentPage()
                return
            }
            this.$router.push({ path: '/tracks/' + value })
        },
        playTrack(index) {
            if (this.albums[index].id === this.trackId) {
                return this.$store.dispatch('playPause')
            }
            return this.$store.dispatch('playTrackList', {
                tracks: this.albums,
                index
            })
        },
        playAll() {
            if (!this.albums.length) {
                return
            }
            return this.$store.dispatch('playTrackList', {
                tracks: this.albums,
                index: 0
            })
        },
        playRandom() {
            if (!this.albums.length) {
                return
            }
            const index = Math.floor(Math.random() * this.albums.length)
            return this.playTrack(index)
        },
        formatDurationLong(totalSeconds) {
            if (!totalSeconds) {
                return '00:00'
            }
            const hours = Math.floor(totalSeconds / 3600)
            const minutes = Math.floor((totalSeconds % 3600) / 60)
            const seconds = Math.floor(totalSeconds % 60)
            const pad = value => String(value).padStart(2, '0')
            if (hours > 0) {
                return `${hours}:${pad(minutes)}:${pad(seconds)}`
            }
            return `${pad(minutes)}:${pad(seconds)}`
        }
    }
}
</script>

<style scoped>
.track-library {
    --track-radius: 18px;
    --track-border: oklch(var(--bc) / 0.12);
    --track-muted: oklch(var(--bc) / 0.62);
    --track-soft: color-mix(in oklch, oklch(var(--b2)) 72%, transparent);
    min-height: 0;
    overflow-x: hidden;
    border-radius: 1rem;
    color: oklch(var(--bc));
    background:
        radial-gradient(circle at 12% 8%, color-mix(in srgb, oklch(var(--p)) 16%, transparent), transparent 28rem),
        radial-gradient(circle at 88% 4%, color-mix(in srgb, oklch(var(--a)) 12%, transparent), transparent 26rem),
        oklch(var(--b2));
    padding: 18px;
}

.track-hero,
.track-toolbar,
.track-status-strip,
.track-content {
    max-width: 1480px;
    margin-left: auto;
    margin-right: auto;
}

.track-hero {
    position: relative;
    display: grid;
    grid-template-columns: minmax(0, 1.25fr) minmax(300px, 0.75fr);
    gap: 28px;
    align-items: stretch;
    min-height: 230px;
    margin-bottom: 14px;
    border: 1px solid var(--track-border);
    border-radius: var(--track-radius);
    background:
        radial-gradient(circle at 86% 18%, color-mix(in oklch, oklch(var(--p)) 18%, transparent), transparent 24rem),
        linear-gradient(
            105deg,
            oklch(var(--b1) / 0.98) 0%,
            oklch(var(--b1) / 0.96) 42%,
            color-mix(in oklch, oklch(var(--b2)) 88%, oklch(var(--p)) 6%) 68%,
            color-mix(in oklch, oklch(var(--b3)) 84%, oklch(var(--p)) 10%) 100%
        ),
        oklch(var(--b1));
    box-shadow: 0 20px 60px oklch(var(--bc) / 0.08);
    isolation: isolate;
    overflow: hidden;
}

.track-hero__copy {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: clamp(24px, 4vw, 44px);
}

.track-hero__label {
    width: fit-content;
    margin-bottom: 14px;
    padding: 5px 10px;
    border-radius: 999px;
    background: oklch(var(--p) / 0.14);
    color: oklch(var(--p));
    font-size: 12px;
    font-weight: 700;
}

.track-hero h1 {
    max-width: 680px;
    margin: 0;
    font-size: clamp(30px, 4vw, 54px);
    line-height: 1.04;
    font-weight: 800;
    letter-spacing: 0;
}

.track-hero p {
    max-width: 62ch;
    margin-top: 16px;
    color: var(--track-muted);
    font-size: 15px;
    line-height: 1.75;
}

.track-hero__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 22px;
}

.track-hero__deck {
    position: relative;
    min-height: 230px;
    padding: 28px;
    background: transparent;
    isolation: isolate;
    overflow: hidden;
}

.track-hero__deck::before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 0;
    background:
        linear-gradient(
            90deg,
            transparent 0%,
            color-mix(in oklch, oklch(var(--b3)) 42%, transparent) 46%,
            color-mix(in oklch, oklch(var(--b3)) 68%, oklch(var(--p)) 8%) 100%
        );
    pointer-events: none;
}

.track-strip {
    position: absolute;
    z-index: 1;
    left: 28px;
    right: 28px;
    top: calc(30px + var(--track-index) * 44px);
    display: grid;
    grid-template-columns: 52px minmax(0, 1fr);
    gap: 12px;
    align-items: center;
    min-height: 68px;
    padding: 8px 12px 8px 8px;
    border: 1px solid oklch(var(--bc) / 0.12);
    border-radius: 16px;
    background: oklch(var(--b1) / 0.86);
    box-shadow: 0 16px 34px oklch(var(--bc) / 0.14);
    transform: translateX(calc(var(--track-index) * 10px));
}

.track-strip img {
    width: 52px;
    aspect-ratio: 1;
    border-radius: 12px;
    object-fit: cover;
}

.track-strip strong,
.track-strip span {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.track-strip strong {
    font-size: 14px;
}

.track-strip span {
    margin-top: 2px;
    color: var(--track-muted);
    font-size: 12px;
}

.track-toolbar {
    position: sticky;
    top: 0;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 12px;
    align-items: center;
    margin-bottom: 12px;
    padding: 10px;
    border: 1px solid var(--track-border);
    border-radius: var(--track-radius);
    background: color-mix(in oklch, oklch(var(--b1)) 92%, transparent);
    backdrop-filter: blur(14px);
    z-index: 3;
}

.track-toolbar__tabs {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    padding-bottom: 1px;
}

.track-tab,
.track-icon-button {
    min-height: 38px;
    border-radius: 999px;
    border: 1px solid transparent;
    background: transparent;
    color: oklch(var(--bc) / 0.72);
    transition: background-color 180ms ease, color 180ms ease, border-color 180ms ease, transform 180ms ease;
}

.track-tab {
    flex: 0 0 auto;
    padding: 0 14px;
    font-size: 13px;
    font-weight: 700;
    white-space: nowrap;
}

.track-tab:hover,
.track-icon-button:hover {
    background: oklch(var(--b2));
    color: oklch(var(--bc));
}

.track-tab:active,
.track-icon-button:active,
.track-scroll-top:active {
    transform: translateY(1px);
}

.track-tab.is-active,
.track-icon-button.is-active {
    background: oklch(var(--p));
    color: oklch(var(--pc));
    border-color: oklch(var(--p));
}

.track-toolbar__actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.track-icon-button {
    display: inline-flex;
    width: 40px;
    align-items: center;
    justify-content: center;
}

.track-status-strip {
    display: grid;
    grid-template-columns: 1.4fr repeat(3, 1fr);
    gap: 10px;
    margin-bottom: 12px;
}

.track-status-strip > div {
    min-width: 0;
    padding: 14px 16px;
    border: 1px solid var(--track-border);
    border-radius: 16px;
    background: var(--track-soft);
}

.track-status-strip__label {
    display: block;
    margin-bottom: 3px;
    color: var(--track-muted);
    font-size: 12px;
}

.track-status-strip strong {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 18px;
}

.track-content {
    padding: 2px 0 28px;
}

.track-loading,
.track-empty {
    display: flex;
    min-height: 260px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    border: 1px solid var(--track-border);
    border-radius: var(--track-radius);
    background: oklch(var(--b1) / 0.74);
    text-align: center;
}

.track-loading__rows {
    display: grid;
    width: min(560px, 82vw);
    gap: 10px;
}

.track-loading__rows span {
    height: 42px;
    border-radius: 14px;
    background: linear-gradient(110deg, oklch(var(--b2)), oklch(var(--b3)), oklch(var(--b2)));
    background-size: 200% 100%;
}

.track-loading p,
.track-empty p {
    max-width: 36ch;
    color: var(--track-muted);
    font-size: 14px;
}

.track-empty__art {
    display: flex;
    height: 88px;
    align-items: flex-end;
    gap: 10px;
}

.track-empty__art span {
    width: 18px;
    border-radius: 999px;
    background: oklch(var(--p) / 0.42);
}

.track-empty__art span:nth-child(1) {
    height: 42px;
}

.track-empty__art span:nth-child(2) {
    height: 76px;
    background: oklch(var(--p));
}

.track-empty__art span:nth-child(3) {
    height: 56px;
}

.track-empty h3 {
    margin: 0;
    font-size: 20px;
    font-weight: 800;
}

.track-scroll-top {
    position: fixed;
    right: 24px;
    bottom: 24px;
    display: inline-flex;
    width: 44px;
    height: 44px;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    background: oklch(var(--p));
    color: oklch(var(--pc));
    box-shadow: 0 12px 30px oklch(var(--bc) / 0.2);
    transition: transform 180ms ease, background-color 180ms ease;
    z-index: 4;
}

.scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.scrollbar-hide::-webkit-scrollbar {
    display: none;
}

@media (prefers-reduced-motion: no-preference) {
    .track-hero,
    .track-toolbar,
    .track-status-strip,
    .track-content {
        animation: trackFadeIn 360ms ease both;
    }

    .track-loading__rows span {
        animation: trackSkeleton 1.2s ease-in-out infinite;
    }
}

@keyframes trackFadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes trackSkeleton {
    0% {
        background-position: 100% 0;
    }
    100% {
        background-position: -100% 0;
    }
}

@media screen and (max-width: 900px) {
    .track-library {
        padding: 12px;
    }

    .track-hero {
        grid-template-columns: 1fr;
    }

    .track-hero__deck {
        min-height: 230px;
    }

    .track-toolbar {
        grid-template-columns: 1fr;
    }

    .track-toolbar__actions {
        justify-content: flex-end;
    }

    .track-status-strip {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media screen and (max-width: 640px) {
    .track-hero__copy {
        padding: 22px;
    }

    .track-hero h1 {
        font-size: 30px;
    }

    .track-hero__actions .btn {
        flex: 1 1 auto;
    }

    .track-strip {
        left: 16px;
        right: 26px;
        grid-template-columns: 44px minmax(0, 1fr);
        min-height: 60px;
        transform: translateX(calc(var(--track-index) * 6px));
    }

    .track-strip img {
        width: 44px;
    }

    .track-status-strip {
        grid-template-columns: 1fr;
    }

    .track-scroll-top {
        right: 16px;
        bottom: 16px;
    }
}
</style>
